/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailBookingController', ProjectDetailBookingController);

    ProjectDetailBookingController.$inject = ['$state', 'ProjectDetailBooking', 'BookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams', 'entity', '$http', 'DateUtils'];

    function ProjectDetailBookingController($state, ProjectDetailBooking, BookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams, entity, $http, DateUtils) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.project = entity;
        vm.dataExport = dataExport;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                BookingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProjectDetailBooking.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    projectID: $stateParams.id
                }, onSuccess, onError);
            }

            // could be replaced with vm.project.bookedPlaces but this way it get's refreshed every time (not only with project reload)
            $http.get('api/board/bookings/summary', {
                params: {
                    projectID: entity.id
                }
            }).then(function(response) {
                vm.status = response.data;
                vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
                vm.freePlaces = vm.project.places - vm.validPlaces
            });

            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
                for(var i = 0; i < vm.bookings.length; i++) {
                    for(var u = 0; u < vm.bookings[i].sbfTimeSlots.length; u++) {
                        vm.bookings[i].sbfTimeSlots[u].fromTime = DateUtils.convertDateTimeFromServer(vm.bookings[i].sbfTimeSlots[u].fromTime);
                        vm.bookings[i].sbfTimeSlots[u].toTime = DateUtils.convertDateTimeFromServer(vm.bookings[i].sbfTimeSlots[u].toTime);
                    }
                }
                //console.log(vm.bookings);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                id: $stateParams.id
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/bookings/export/', {params:{
                projectID: $stateParams.id
            }}).then(function(response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }
    }
})();
